import { sortByAbc } from '../helpers';

export default class PassportDirectory {
    constructor(directory) {
        this.directory = directory;
    }

    getDisciplines() {
        return this.directory.disciplines.map((data) => {
            return {
                id: data[0],
                title: data[1],
            };
        });
    }

    getCommunes(disciplineId) {
        const communes = [];
        const addedCommunes = {};

        this.directory.clubs.forEach((club) => {
            const targetCommune = this.directory.communes.find(c => +c[0] === +club.commune);

            if (!targetCommune) {
                return;
            }

            if (club.disciplines.some(discipline => +discipline === +disciplineId)) {
                const commune = {
                    id: club.commune,
                    title: targetCommune[1].title,
                };

                if (!addedCommunes[commune.id]) {
                    communes.push(commune);
                }

                addedCommunes[commune.id] = true;
            }
        });

        return communes.sort((a, b) => sortByAbc(a.title, b.title));
    }

    getClubs(disciplineId, communeId) {
        const targetClubs = this.directory.clubs.filter((club) => {
            return +club.commune === +communeId && club.disciplines.some(discipline => +discipline === +disciplineId);
        });

        return targetClubs.map((club) => {
            return {
                id: club.uid,
                title: club.title,
            };
        });
    }

    getFederations(clubId) {
        const federations = [];
        const targetClub = this.directory.clubs.find(club => +clubId === +club.uid);

        targetClub.federations.forEach((federationId) => {
            const targetFederation = this.directory.federations.find(federation => +federationId === +federation[0]);

            if (!targetFederation) {
                console.warn('federation not found');
                return;
            }

            const federation = {
                id: +federationId,
                title: targetFederation[1],
            };

            federations.push(federation);
        });

        return federations.sort((a, b) => sortByAbc(a.title, b.title));
    }

    getCommunesByZipCode(zipCode) {
        return this.directory.communes
            .filter(value => +value[1].zip === +zipCode)
            .map((value) => {
                return {
                    id: value[0],
                    title: value[1].title,
                };
            });
    }

    static async create() {
        if (!PassportDirectory.instance) {
            const elWithDirectoryPath = document.querySelector('[data-passport-json]');

            if (!elWithDirectoryPath) {
                console.warn('Passport directory in not exist');
                return;
            }

            const directoryPath = elWithDirectoryPath.getAttribute('data-passport-json');
            const res = await fetch(directoryPath);
            const json = await res.json();

            // Sort disciplines by alphabetical order
            const sortedDisciplines = Object.entries(json.disciplines).sort(([, a], [, b]) => sortByAbc(a, b));
            const sortedCommunes = Object.entries(json.communes).sort(([, a], [, b]) => sortByAbc(a.title, b.title));
            const federationsArray = Object.entries(json.federations);         
            const sortedClubs = json.clubs.sort((a, b) => sortByAbc(a.title, b.title));
                
            json.disciplines = sortedDisciplines;
            json.communes = sortedCommunes;
            json.federations = federationsArray;
            json.clubs = sortedClubs;

            PassportDirectory.instance = new PassportDirectory(json);
        }

        return PassportDirectory.instance;
    }
}
